export enum RequestSourceEnum {
  RTP = 'RTP',
  AVINODE = 'Avinode',
  STAFF_CREATED = 'Staff Created',
  ELAC = 'ELAC',
  EXPLORER = 'Explorer',
}